import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.carrier}carriers/files/${COMMON_QUERY_PARAMS.FILE_ID}/urls/${COMMON_QUERY_PARAMS.MODULE_DEFINITION_ID}/${COMMON_QUERY_PARAMS.MODULE_INSTANCE_ID}`;

interface GetShippingLabelQueryArgs {
  fileId: string;
  moduleDefinitionId: string;
  moduleInstanceId: string;
}

async function getShippingLabelQuery({
  fileId,
  moduleDefinitionId,
  moduleInstanceId,
}: GetShippingLabelQueryArgs): Promise<
  BackResponse<string> | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId)
      .replace(COMMON_QUERY_PARAMS.MODULE_DEFINITION_ID, moduleDefinitionId)
      .replace(COMMON_QUERY_PARAMS.MODULE_INSTANCE_ID, moduleInstanceId);

    return await apiCall<BackResponse<string>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getShippingLabelQuery;
